// extracted by mini-css-extract-plugin
export default {"content":"page-title_content__SLTJl","title":"page-title_title__MP49S","sub_title":"page-title_sub_title__1Byjs"};